import cn from 'classnames';

interface FilterSectionProps {
    first?: boolean;
    children: React.ReactNode;
    className?: string;
}

const FilterSection = (props: FilterSectionProps) => {
    const { first, children, className } = props;

    return (
        <div
            className={cn('py-2.5 px-4 overflow-x-auto', {
                'flex items-center justify-between': first,
                'border-t border-neutral-700': !first,
                [`${className}`]: className
            })}>
            {children}
        </div>
    );
};

export default FilterSection;
